export const BUSINESS_NAME = "Bloom Salon";
export const BUSINESS_ADDRESS = "01, Bagalgunte, 1st Cross, Hesarghatta Road, Bengaluru";
export const BUSINESS_PHONE_DISPLAY = "+91 99000 06861";
export const BUSINESS_PHONE_E164 = "919900006861";
export const INSTAGRAM_URL = "https://www.instagram.com/bloomsalonsblr/";

export const highlights = [
  {
    number: "01",
    title: "Hair Styling",
    description:
      "Precision cuts, smooth finishing, and styling sessions with a polished salon feel."
  },
  {
    number: "02",
    title: "Beauty Care",
    description:
      "Skin care, touch-ups, and beauty services arranged in a clean, elegant flow."
  },
  {
    number: "03",
    title: "Unisex Grooming",
    description:
      "A welcoming experience for women and men with everyday grooming and occasion-ready care."
  }
];

export const gallery = [
  {
    title: "Warm Interior",
    description: "Soft lighting, mirrors, premium chairs, and a relaxed neighbourhood salon mood.",
    variant: "interior",
    image: null
  },
  {
    title: "Style Station",
    description: "A refined styling corner for cuts, color, finishing, and consultation moments.",
    variant: "station",
    image: null
  },
  {
    title: "Beauty Rituals",
    description: "Beauty essentials and self-care sessions presented with a premium visual tone.",
    variant: "ritual",
    image: null
  }
];

export const services = [
  "Hair styling",
  "Hair cut",
  "Hair care",
  "Skin care",
  "Makeup"
];
